<template>
  <div v-if="primaryContact">
    <h3 class="contact--name" @click="openContactModal">
      {{ contact.full_name !== " " ? contact.full_name : "Unknown Name" }}
    </h3>

    <sensitive-data-wrapper>
      <p class="contact--info">
        {{ contact.email_address ? contact.email_address : "No Email" }}
        <template> |</template>
        {{ contact.phone_1 ? $utils.formatNumber(contact.phone_1) : "No Phone" }}
      </p>
    </sensitive-data-wrapper>

    <comm-buttons
      class="my-50"
      style="max-width: 240px"
      :record="record"
      :contact="contact"
      include-button-text
      is-primary
      size="is-small"
    ></comm-buttons>

    <p class="comm--info flex flex-vertical-center">
      <span class="comm--info--label flex-vertical-center">
        <b-tooltip label="Refresh Comms" position="is-left" type="is-dark">
          <icon-default
            icon="refresh"
            @click="reloadComms"
            size="is-small"
            class="comm--info--icon"
          ></icon-default>
        </b-tooltip>
        Outbound:
      </span>
      <template v-if="!loadingComms">{{ callsCount }} calls, {{ textsCount }} texts, and {{ emailsCount }} email
      </template>
      <template v-else>loading...</template>
    </p>
    <p class="comm--info">
      <span class="comm--info--label">Lead Entered:</span>
      <span class="comm--info--value">
        {{ enteredStatus }}
      </span>
    </p>
    <p class="comm--info" v-if="lastAttempt">
      <span class="comm--info--label">Last Attempt:</span>
      <span v-if="!loadingComms" class="comm--info--value">
        {{ lastAttempt.type }}ed {{ lastAttempt.datetime }}
      </span>
      <template v-else>loading...</template>
    </p>
  </div>
  <div v-else class="flex flex-centered flex-vertical-center" style="height: 100%">
    <p class="is-italic">No primary contact</p>
  </div>
</template>

<script>
import CommButtons from "../../../../../components/comms/CommButtons";
import {ENUMS} from "../../../../../services/enums";
import dates from "../../../../../services/dates";
import router from "../../../../../router";
import SensitiveDataWrapper from "../../../../../components/SensitiveDataWrapper.vue";

export default {
  name: "ContactingBoxContactComms",
  components: {SensitiveDataWrapper, CommButtons},
  props: {
    record: {
      type: Object,
      required: true
    },
    comms: {
      type: Array,
      required: true
    },
    primaryContact: Object,
  },
  data() {
    return {
      loadingComms: false,
      currentComms: this.comms,
    };
  },
  computed: {
    contact() {
      return this.primaryContact;
    },
    outboundComms() {
      const outboundComms = this.currentComms.filter(comm => comm.communication_direction === ENUMS.CommunicationDirectionEnum.Outbound.value);

      return outboundComms.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
    },
    callsCount() {
      const calls = this.outboundComms.filter(comm => comm.type === ENUMS.CommunicationTypeEnum.Call.value);
      return calls.length;
    },
    textsCount() {
      const texts = this.outboundComms.filter(comm => comm.type === ENUMS.CommunicationTypeEnum.Text.value);
      return texts.length;
    },
    emailsCount() {
      const emails = this.outboundComms.filter(comm => comm.type === ENUMS.CommunicationTypeEnum.Email.value);
      return emails.length;
    },
    lastAttempt() {
      if (this.outboundComms[0]) {
        const lastComm = this.outboundComms[0];

        return {
          type: this.$utils.newGetEnumLabel(lastComm.type, ENUMS.CommunicationTypeEnum),
          datetime: dates.formatAsDateTime(lastComm.created_at),
        };
      }

      return null;
    },
    enteredStatus() {
      return dates.formatAsDateTime(this.record.entered_status_at);
    }
  },
  methods: {
    openContactModal() {
      router.replace({query: {contact: this.primaryContact.id}});
    },
    reloadComms() {
      this.loadingComms = true;

      this.$api.communicationLogs.allForRecord(this.record.id).then(response => {
        this.currentComms = response.data.data;
        this.loadingComms = false;
      });
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../../styles/variables/variables";

.contact {

  &--name {
    color: $link;
    font-weight: bold;
    cursor: pointer;

    &:hover {
      color: $link-hover;
    }
  }

  &--info {
    margin-top: 4px;
    font-size: 0.75rem;
  }
}

.comm--info {
  margin-top: 4px;
  font-size: 0.875rem;
  white-space: nowrap;

  &--icon {
    margin-right: 2px;
    cursor: pointer;

    &:hover {
      color: $primary;
    }
  }

  &--label {
    display: inline-flex;
    min-width: 100px;
    font-size: 0.75rem;
    color: $text-muted;
    text-transform: uppercase;
  }

  &--value {
    cursor: help;
  }
}
</style>

